module.exports = __webpack_public_path__ + "static/media/gulp5.86235b1a.mp3";